export default "__VITE_ASSET__D7X3Aqg2__"